import { suppliersTableColumnDefinitions } from '../constants/suppliersTableColumnDefinitions'
import { SuppliersTableColumnKey } from '../types/suppliersTableColumnKey'

interface BuildSuppliersTableColumnConfigurationOptions {
  excludedColumnKeys: SuppliersTableColumnKey[]
}

export const buildSuppliersTableColumnConfiguration = ({
  excludedColumnKeys,
}: BuildSuppliersTableColumnConfigurationOptions) =>
  suppliersTableColumnDefinitions.filter((column) => !excludedColumnKeys.includes(column.key))
